import 'bootstrap/dist/css/bootstrap.css';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ConfigLoader from './components/ConfigLoader';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

// Use ConfigLoader to load config before rendering App
ReactDOM.render(
  <ConfigLoader
    ready={(config) => <App configData={config} />}
  />,
  rootElement
);


